// src/SuccessPage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";

export default function SuccessPage() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="header"><span>Bank of Mars</span></div>
      <div className="container">
        <div className="card">
          <h2>Registration Successful 🎉</h2>
          <p>Your account and information have been submitted successfully.</p>
          <button onClick={() => navigate('/signin')}>Back to Login</button>
        </div>
      </div>
    </div>
  );
}